import '../../styles/loader.css'

export default function Loader() {
  return <div className='loader mx-auto'></div>
}
